import {createAsyncThunk} from "@reduxjs/toolkit";
import {iStateMessage} from "@/customTypes/GenericReduxTypes";
import {iGenericResponse} from "@/customTypes/CommonServiceTypes";
import {curryGetThunkName} from "@/projectUtils/ReduxUtil";
import {httpStatusCodes} from "@/customTypes/NetworkTypes";
import { deliveryManService } from "@/services/api/cresivoxServer";
import { REDUCER_NAME, iDeliveryDTO, iUpdateOrderStatusPayload} from './Type';

// import { REDUCER_NAME, iDeliveryDTO} from './Type';
// import { REDUCER_NAME ,iDeliveryDTO} from './Type'
const curriedGetThunkName = curryGetThunkName(REDUCER_NAME);

export const addDeliveryMan = createAsyncThunk<
    iGenericResponse<any | null> | null,
    iDeliveryDTO,
    {
        rejectValue: iStateMessage;
    }
>(
    curriedGetThunkName("addDeliveryMan"),
    // @ts-expect-error: Type mismatch between LoginSchema and userLogin expected types
    async (payload, {rejectWithValue}) => {
        try {
            const response = await deliveryManService.addDeliveryMan(payload);
            if (response) {
                const {httpStatusCode, data, message} = response;
                switch (httpStatusCode) {
                    case httpStatusCodes.SUCCESS_OK: {
                        if (data && data.data) {
                            return {
                                data: {
                                    orders: data.data,
                                    message,
                                }
                            };
                        } else {
                            return rejectWithValue({
                                httpStatusCode,
                                message,
                            });
                        }
                    }
                    default: {
                        return rejectWithValue({
                            httpStatusCode,
                            message,
                        });
                    }
                }
            } else {
                return rejectWithValue({
                    message: "No response received",
                });
            }
        } catch (error) {
            return rejectWithValue({
                message: "Something went wrong",
            });
        }
    },
);

export const updateDeliveryMan = createAsyncThunk<
    iGenericResponse<any | null> | null,
    {userId:string, data: iDeliveryDTO},
    {
        rejectValue: iStateMessage;
    }
>(
    curriedGetThunkName("updateDelivery"),
    // @ts-expect-error: Type mismatch between LoginSchema and userLogin expected types
    async ({userId,data}, {rejectWithValue}) => {
        try {
            const response = await deliveryManService.updateDeliveryMan(userId,data);
            if (response) {
                const {httpStatusCode, data, message} = response;

                switch (httpStatusCode) {
                    case httpStatusCodes.SUCCESS_OK: {
                        if (data && data.data) {
                            return {
                                data: {
                                    data: data.data,
                                    message,
                                }
                            };
                        } else {
                            return rejectWithValue({
                                httpStatusCode,
                                message,
                            });
                        }
                    }
                    default: {
                        return rejectWithValue({
                            httpStatusCode,
                            message,
                        });
                    }
                }
            } else {
                return rejectWithValue({
                    message: "No response received",
                });
            }
        } catch (error) {
            return rejectWithValue({
                message: "Something went wrong",
            });
        }
    },
);

export const getDeliveryList = createAsyncThunk<
    iGenericResponse<any | null> | null,
    void,
    {
        rejectValue: iStateMessage;
    }
>(
    curriedGetThunkName("DeliveryList"),
    // @ts-expect-error: Type mismatch between LoginSchema and userLogin expected types
    async (arg, {rejectWithValue}) => {
        try {
            const response = await deliveryManService.getDeliveryManList();
            if (response) {
                const {httpStatusCode, data, message} = response;

                switch (httpStatusCode) {
                    case httpStatusCodes.SUCCESS_OK: {
                        if (data && data.data) {
                            return {
                                data:{
                                    httpStatusCode,
                                    data: data.data,
                                    message,
                                }
                            };
                        } else {
                            return rejectWithValue({
                                httpStatusCode,
                                message,
                            });
                        }
                    }
                    default: {
                        return rejectWithValue({
                            httpStatusCode,
                            message,
                        });
                    }
                }
            } else {
                return rejectWithValue({
                    message: "No response received",
                });
            }
        } catch (error) {
            return rejectWithValue({
                message: "Something went wrong",
            });
        }
    },
);

export const deleteDelivery = createAsyncThunk<
    iGenericResponse<any | null> | null,
    {userId:string},
    {
        rejectValue: iStateMessage;
    }
>(
    curriedGetThunkName("deleteDelivery"),
    // @ts-expect-error: Type mismatch between LoginSchema and userLogin expected types
    async ({userId}, {rejectWithValue}) => {
        try {
            const response = await deliveryManService.deleteDelivery(userId);
            if (response) {
                const {httpStatusCode, data, message} = response;

                switch (httpStatusCode) {
                    case httpStatusCodes.SUCCESS_OK: {
                        if (data && data.data) {
                            return {
                                data: data.data,
                                message,
                            };
                        } else {
                            return rejectWithValue({
                                httpStatusCode,
                                message,
                            });
                        }
                    }
                    default: {
                        return rejectWithValue({
                            httpStatusCode,
                            message,
                        });
                    }
                }
            } else {
                return rejectWithValue({
                    message: "No response received",
                });
            }
        } catch (error) {
            return rejectWithValue({
                message: "Something went wrong",
            });
        }
    },
);

export const addDeliveryManOrder = createAsyncThunk<
    iGenericResponse<any | null> | null,
    {orderId: string, deliveryManId: string},
    {
        rejectValue: iStateMessage;
    }
>(
    curriedGetThunkName("addDeliveryManOrder"),
    // @ts-expect-error: Type mismatch between LoginSchema and userLogin expected types
    async ({orderId, deliveryManId}, {rejectWithValue}) => {
        try {
            const response = await deliveryManService.addDeliveryManOrder(orderId, deliveryManId);
            if (response) {
                const {httpStatusCode, data, message} = response;

                switch (httpStatusCode) {
                    case httpStatusCodes.SUCCESS_OK: {
                        if (data && data.data) {
                            return {
                                data: {
                                    data: data.data,
                                    message,
                                }
                            };
                        } else {
                            return rejectWithValue({
                                httpStatusCode,
                                message,
                            });
                        }
                    }
                    default: {
                        return rejectWithValue({
                            httpStatusCode,
                            message,
                        });
                    }
                }
            } else {
                return rejectWithValue({
                    message: "No response received",
                });
            }
        } catch (error) {
            return rejectWithValue({
                message: "Something went wrong",
            });
        }
    },
);

export const getDeliveryManOrderList = createAsyncThunk<
    iGenericResponse<any | null> | null,
    void,
    {
        rejectValue: iStateMessage;
    }
>(
    curriedGetThunkName("getDeliveryManOrderList"),
    // @ts-expect-error: Type mismatch between LoginSchema and userLogin expected types
    async (arg, {rejectWithValue}) => {
        try {
            const response = await deliveryManService.getDeliveryManOrderList();
            if (response) {
                const {httpStatusCode, data, message} = response;

                switch (httpStatusCode) {
                    case httpStatusCodes.SUCCESS_OK: {
                        if (data && data.data) {
                            return {
                                data:{
                                    httpStatusCode,
                                    data: data.data,
                                    message,
                                }
                            };
                        } else {
                            return rejectWithValue({
                                httpStatusCode,
                                message,
                            });
                        }
                    }
                    default: {
                        return rejectWithValue({
                            httpStatusCode,
                            message,
                        });
                    }
                }
            } else {
                return rejectWithValue({
                    message: "No response received",
                });
            }
        } catch (error) {
            return rejectWithValue({
                message: "Something went wrong",
            });
        }
    },
);

// ✅ NEW: Update Order Status by Delivery Man
export const updateOrderStatusByDeliveryMan = createAsyncThunk<
    iGenericResponse<any | null> | null,
    iUpdateOrderStatusPayload,
    {
        rejectValue: iStateMessage;
    }
>(
    curriedGetThunkName("updateOrderStatusByDeliveryMan"),
    // @ts-expect-error: Type mismatch between payload types
    async (payload, {rejectWithValue}) => {
        try {
            const response = await deliveryManService.updateOrderStatusByDeliveryMan(payload);
            if (response) {
                const {httpStatusCode, data, message} = response;

                switch (httpStatusCode) {
                    case httpStatusCodes.SUCCESS_OK: {
                        if (data && data.data) {
                            return {
                                data: {
                                    httpStatusCode,
                                    data: data.data,
                                    message,
                                }
                            };
                        } else {
                            return rejectWithValue({
                                httpStatusCode,
                                message,
                            });
                        }
                    }
                    default: {
                        return rejectWithValue({
                            httpStatusCode,
                            message,
                        });
                    }
                }
            } else {
                return rejectWithValue({
                    message: "No response received",
                });
            }
        } catch (error) {
            return rejectWithValue({
                message: "Something went wrong while updating order status",
            });
        }
    },
);